import { PaymentModule } from '@sm-dashboard/types';
import { WORLD_PAYMENT_MODULES } from './paymentModulesWorld';

export const PAYMENT_MODULES: PaymentModule[] = [
  {
    tag: 'סתם',
    name: 'ניהול סת"ם',
    description: 'ניהול בדיקות סת"ם והזמנות יודאיקה',
    price: '40 ₪',
    features: ['ניהול בדיקות סת"ם', 'הודעות עדכון סטטוס ללקוח', 'דוחות ממצאי בדיקה', 'ניהול הזמנות יודאיקה'],
    routes: ['/tools/stam-checks/system'],
    variant: 'primary',
    myopId: 'button-subscribe-stam',
    planId: '41a87a63-5d36-426f-aa0c-7e6e7cc1cb4a'
  },
  {
    tag: 'CRM',
    name: 'אנשים (CRM)',
    description: 'ניהול אנשי קשר וקהילה ומעקב אחריהם',
    price: '200 ₪',
    features: [
      'ניהול אנשי קשר',
      'קבוצות ותגיות',
      'דיוור בווטסאפ, מייל וסמס',
      'תבניות מוכנות ומעוצבות לשליחה במייל',
      'עורך AI חכם לניסוח הודעות',
      'מודול טפסים ושאלונים',
      'דו"ח לרבי',
      'לוח בקרה חכם',
      'תזכורות וניהול משימות',
      'רשימת ימי הולדת שבועית לווטסאפ'
    ],
    routes: ['/crm', '/crm/forms/user-forms'],
    variant: 'primary',
    myopId: 'button-subscribe-crm',
    planId: '10d91307-8e48-4d59-ad08-ae8235dc04e8'
  },
  {
    tag: 'קדמה עיצובים',
    name: 'קדמה',
    description: 'מנוי קנבה פרו ומאגר עיצובים מתעדכן',
    price: '180 ₪',
    features: [
      'מנוי קנבה פרו',
      '2000+ עיצובים לשימוש חופשי ללא הגבלה',
      'מאגר מתעדכן כל הזמן',
      'סרטונים להתאמה אישית',
      'עיצובים למסכים',
      'עיצובים לשלטים',
      'עיצובים לרולאפים'
    ],
    routes: ['no-route'],
    variant: 'secondary',
    myopId: 'button-subscribe-kedma',
    planId: '94ca1cf9-7b94-4b6d-aad5-93ebbecdf8bb'
  },
  {
    tag: 'קדמה דפים אישיים',
    name: 'דפים אישיים',
    description: 'דפי אירועים, קמפיינים וסליקה אישית',
    price: '180 ₪',
    features: [
      'דפי אירועים',
      'דפי קמפיינים',
      'נתוני קמפיין בזמן אמת',
      'יעדים ויחידות תרומה',
      'סליקה אישית',
      'עיצוב דפים בהתאמה אישית',
      'ספריית דפים מעוצבים',
      'טפסי הרשמה',
      'מכירת כרטיסים'
    ],
    routes: [
      '/outreach/personal-pages',
      '/org/event-sales',
      '/desk/registerations',
      '/outreach/campaign-creation',
      '/outreach/event-creation',
      '/outreach/information-page-creation',
      '/outreach/registration-creation',
      '/campaigns'
    ],
    variant: 'primary',
    myopId: 'button-subscribe-private-page',
    planId: '66d8bce3-e95c-4649-901f-f0bb29853e0d'
  },
  {
    tag: 'קהילה',
    name: 'קהילה',
    description: 'מנוי מלא הכולל את כל המודולים והפיצרים',
    price: '500 ₪',
    features: [
      'כל הפיצרים של ניהול סת"ם',
      'כל הפיצרים של אנשים (CRM)',
      'כל הפיצרים של קדמה עיצובים',
      'כל הפיצרים של דפים אישיים',
      'גישה מלאה לכל המודולים',
      'תמיכה מועדפת'
    ],
    routes: [
      '/tools/stam-checks/system',
      '/crm',
      '/crm/forms/user-forms',
      '/outreach/personal-pages',
      '/org/event-sales',
      '/desk/registerations',
      '/outreach/campaign-creation',
      '/outreach/event-creation',
      '/outreach/information-page-creation',
      '/outreach/registration-creation',
      '/campaigns'
    ],
    variant: 'primary',
    myopId: 'button-subscribe-full',
    planId: '0bc17dc1-29a8-42d8-9e00-5cc1f7f0451b'
  }
  // {
  //   tag: 'קדמה פלוס',
  //   name: 'קדמה פלוס',
  //   description: 'מנוי פרימיום הכולל קדמה עיצובים + תמיכה מיוחדת',
  //   price: '158 ₪',
  //   features: ["כל הפיצ'רים של קדמה", 'גישה לקנבה מלאה', 'תמיכה טכנית מוקדמת'],
  //   routes: ['no-route'],
  //   variant: 'secondary'
  // }
];

export const getPaymentModules = (isWorld = false): PaymentModule[] =>
  isWorld ? WORLD_PAYMENT_MODULES : PAYMENT_MODULES;

export const getAllModulesByRoute = (route: string, isWorld = false): PaymentModule[] => {
  return (
    getPaymentModules(isWorld).filter(module =>
      module.routes.some(moduleRoute => route.startsWith(moduleRoute))
    ) || null
  );
};

export const getModuleByTag = (tag: string, isWorld = false): PaymentModule | null => {
  return getPaymentModules(isWorld).find(module => module.tag === tag) || null;
};
